import 'babel-polyfill';
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import numeral from 'numeral';
import VCalendar from './components/v-calendar';
import User from './classes/user';
import Multiselect from 'vue-multiselect'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VueGoogleCharts from 'vue-google-charts'
import CKEditor from '@ckeditor/ckeditor5-vue';

numeral.register('locale', 'nl', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '€ '
  }
});

Vue.use(BootstrapVue);
Vue.use(Vuex);
Vue.use(Datetime);
Vue.use(VueGoogleCharts);
Vue.use(VCalendar, {
  componentPrefix: 'vc'
});
Vue.use(CKEditor);

Vue.component('filter-boolean', require('./components/Filters/Boolean').default);
Vue.component('filter-text', require('./components/Filters/Text').default);
Vue.component('filter-select', require('./components/Filters/Select').default);
Vue.component('filter-date', require('./components/Filters/Date').default);
Vue.component('field-date', require('./components/Fields/Date').default);
Vue.component('field-boolean', require('./components/Fields/Boolean').default);

Vue.component('multiselect', Multiselect)

function commentNode(el, vnode) {
  const comment = document.createComment(' ')

  Object.defineProperty(comment, 'setAttribute', {
    value: () => undefined
  })

  vnode.text = ' '
  vnode.elm = comment
  vnode.isComment = true
  vnode.context = undefined
  vnode.tag = undefined
  vnode.data.directives = undefined

  if (vnode.componentInstance) {
    vnode.componentInstance.$el = comment
  }

  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el)
  }
}

Vue.directive('can', function (el, binding, vnode) {
  const behaviour = binding.modifiers.disable ? 'disable' : 'hide';
  if (User.cant(binding.value)) {
    if (behaviour === 'hide') {
      commentNode(el, vnode);
    } else if (behaviour === 'disable') {
      el.disabled = true
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  store
});
